type EmbryoLinkProps = {
  embryoId: string;
  embryoName: string;
  isOutside?: boolean;
  openInNewTab?: boolean;
  stopPropagation?: boolean;
};

export const EmbryoLink = ({
  embryoId,
  embryoName,
  isOutside,
  openInNewTab,
  stopPropagation,
}: EmbryoLinkProps) => {
  const embryoAppUrl = isOutside
    ? `/embryo/embryo?id=${embryoId}&type=outside`
    : `/embryo/embryo?id=${embryoId}`;
  return (
    <a
      href={embryoAppUrl}
      onClick={stopPropagation ? (e) => e.stopPropagation() : undefined}
      {...(openInNewTab
        ? { target: '_blank', rel: 'noopener noreferrer' }
        : {})}
    >
      {embryoName}
    </a>
  );
};
